import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const fixedArrange = {
    classFixedArrange: {
        list: config => createAPI('/classFixedArrange/list', 'post', config),
        queryTree: config => createAPI('/classFixedArrange/queryTree', 'post', config),
        baseParam: config => createAPI('/classFixedArrange/baseParam', 'post', config),
        classFixed: config => createAPI('/classFixedArrange/classFixed', 'post', config),
        initOption: config => createAPI('/classFixedArrange/initOption', 'post', config),
        checkArrangement: config => createAPI('/classFixedArrange/checkArrangement', 'post', config),
        saveRec: config => createAPI('/classFixedArrange/saveRec', 'post', config),
        checkdeljin: config => createAPI('/classFixedArrange/checkdeljin', 'post', config),
        checkCourse: config => createAPI('/classFixedArrange/checkCourse', 'post', config),
    },
    teacherFixedArrange: {
        list: config => createAPI('/teacherFixedArrange/list', 'post', config),
        queryTree: config => createAPI('/teacherFixedArrange/queryTree', 'post', config),
        teacherFixed: config => createAPI('/teacherFixedArrange/teacherFixed', 'post', config),
        teaTypeOption: config => createAPI('/teacherFixedArrange/teaTypeOption', 'post', config),
        copyLastJSLXJP: config => createAPI('/teacherFixedArrange/copyLastJSLXJP', 'post', config),
        zdynrList: config => createAPI('/teacherFixedArrange/zdynrList', 'post', config),
        initOption: config => createAPI('/teacherFixedArrange/initOption', 'post', config),
        saveZdynr: config => createAPI('/teacherFixedArrange/saveZdynr', 'post', config),
        delZdynr: config => createAPI('/teacherFixedArrange/delZdynr', 'post', config),
        queryZdynrTable: config => createAPI('/teacherFixedArrange/queryZdynrTable', 'post', config),
    },
};


export default fixedArrange;



// WEBPACK FOOTER //
// ./src/api/modules/fixedArrange.js